    import React, { useContext, useEffect, useState } from 'react';
import { QrReader } from '../../components/QrReader';
import { ContentContext } from '../../context/ContentContext';
import { Product } from '../Product';
import { Footer } from '../../components/Layout/Footer';
import { Subscribe } from '../../components/Layout/Subscribe';
import { useParams, useNavigate } from 'react-router-dom';
import { QuienesSomos } from '../QuienesSomos';
import { Progreso } from '../Progreso';
import { Bienvenidos } from '../Bienvenidos';
import { Landing } from '../Landing';
import { BasesCondiciones } from '../BasesCondiciones';
import { BoxRegistro } from '../../components/Layout/BoxRegistro';
import { BoxIngreso } from '../../components/BoxIngreso';
import { WrapperStyled } from './styles';
import { FaWhatsapp } from "react-icons/fa";

const Home = () => {

    const navigate = useNavigate();

    const { slug, producto } = useParams();
    const { goto, 
            setGoto,
            productLoaded,
            setProductLoaded,
            productId,
            setProductId } = useContext(ContentContext);
    const [ ingresoScope, setIngresoScope ] = useState(null);
    /*
    const { qrResult, setQrResult } = useContext(ContentContext);
    const [ productName, setProductName ] = useState("");
    const [ goto, setGoto ] = useState("");

    useEffect(() => {
       
        if(qrResult){
            
            let header = "";
            switch (qrResult) {
                case "gallinas":
                    setProductName("Gallinas Felices");
                    break;
                case "fresh":
                    setProductName("Fresh");
                    break;
                case "santo_padre":
                    setProductName("Santo Padre");
                    break;
                case "pan_batard":
                    setProductName("Panaderia de Pueblo");
                    break;
                default:
                    break;
            }
            setGoto(qrResult);

        }
    
      return () => {}
    }, [qrResult])
    */

    /*
    const { qrResult, setQrResult } = useContext(ContentContext);

    useEffect(() => {
        if(qrResult){
            console.log("qrResult", qrResult)
        }
    
      return () => {}
    }, [qrResult])
    */

    const handleGotoRegistro = () => {
        setIngresoScope("registro");
    }

    const openWhatsApp = (phone, text = "") => {
        // limpia el número y genera la URL compatible con wa.me
        const clean = phone.replace(/\D/g, ""); // elimina todo lo que no sea dígito
        const url = `https://wa.me/${clean}${text ? `?text=${encodeURIComponent(text)}` : ""}`;
        window.open(url, "_blank");
    }

    const handleGoto = (goto) => {
        navigate(goto);
    }

    useEffect(() => {
        switch (slug) {
            case "gallinas":
                setProductId(1);
                break;
            case "panaderia_del_pueblo":
                setProductId(2);
                break;
            case "santo_padre":
                setProductId(3);
                break;
            case "frutas_y_vegetales":
                setProductId(4);
                break;
            case "resena":
                setProductId(5);
                break;
            case "siete_cabritos":
                setProductId(6);
                break;
                
            default:
                break;
        }
       return () => {}
    }, [])

    useEffect(() => {
        console.log("slug --> " , slug)
        console.log("producto --> " , producto)
        if(slug){
            //console.log("--> " , producto)
            setProductLoaded(slug);
        }
    
      return () => {}
    }, [])
    
    return (
        <WrapperStyled>
            
            {slug === undefined ?
                <div className='home'>
                        <div className='vivi'>Viví una experiencia del campo<br/>en medio de la ciudad.</div>
                        
                        {/* <div className='email text_blanco_huevo'>mercadoruralarg@gmail.com</div> */}
                        

                        <div className='inner_menu'>
                            <div
                                onClick={() => handleGoto("conocenos")}
                                className='inner_menu_item'
                            >
                                Conocenos
                            </div>
                            <div
                                onClick={() => handleGoto("eventos")}
                                className='inner_menu_item'
                            >
                                Eventos
                            </div>
                            <div 
                                className='inner_menu_item wp_contact'
                                onClick={() => openWhatsApp("+54 9 11 2473-4769", "Hola")} 
                            >
                                <div className='wp_icon'>
                                    <FaWhatsapp />
                                </div>
                                {/* <div className='wp_numero'>+54 9 11 2473-4769</div> */}
                            </div>
                        </div>
                        
                        <div className='logo'>
                            <img src='/images/logo_white.svg' />
                        </div>
                        <div className='direccion'>Av. Tte. Gral. Donato Álvarez 175</div>

                </div>
            : ""}

            {slug === "conocenos" || slug === "eventos" ?
                <>
                    {/* {ingresoScope ?
                    <BoxIngreso 
                        scope={ingresoScope}
                        setScope={setIngresoScope}
                        trigger={null}
                    /> : ""} */}
                    <Landing />
                    {/* <BoxRegistro 
                        handleGotoRegistro={handleGotoRegistro}
                    /> */}
                    {/* <Footer /> */}
                </>
            : "" }

            {slug === "bienvenidos" ?
                <>
                    {ingresoScope ?
                    <BoxIngreso 
                        scope={ingresoScope}
                        setScope={setIngresoScope}
                        trigger={null}
                    /> : ""}
                    <Bienvenidos />
                    <BoxRegistro 
                        handleGotoRegistro={handleGotoRegistro}
                    />
                    <Footer />
                </>
            : "" }

            {/* {slug === "bases_y_condiciones" ?
                <>
                    <BasesCondiciones />
                    <Subscribe />
                    <Footer />
                </>
            : ""}

            {slug === "quienes_somos" ?
                <>
                    <QuienesSomos />
                    <Subscribe />
                    <Footer />
                </>
            : ""}
            
            {slug === "mi_avance" ?
                <>
                    <Progreso />
                    <Subscribe />
                    <Footer />
                </>
            : ""}

            {slug === 'santo_padre' || slug === 'gallinas' || slug === 'frutas_y_vegetales' || slug === 'panaderia_del_pueblo' || slug === 'siete_cabritos' || slug === 'resena' ?
                <>
                    <Product data={slug} />
                    <Subscribe />
                    <Footer />
                </>
            : ""} */}
            
            {/* {producto ?
                <>
                    <Product data={producto} />
                    <Subscribe />
                    <Footer />
                </>
            : ""} */}
            
        </WrapperStyled>
    );
};

export default Home; 